import { useTranslation } from 'react-i18next';
import { formatDateRange, isUpcoming, sourcePath } from '../../lib/whatsNew.js';

export default function WhatsNewCard({ item, onOpen }) {
  const { t, i18n } = useTranslation();
  const upcoming = isUpcoming(item);
  const dateLabel = formatDateRange(item.date_start, item.date_end, i18n.resolvedLanguage);
  const fromSource = Boolean(sourcePath(item));

  return (
    <button
      type="button"
      onClick={() => onOpen(item)}
      className="card flex w-full flex-col items-start gap-2 text-left"
    >
      <div className="flex w-full flex-wrap items-baseline gap-x-3 gap-y-1">
        <span className="text-[0.7rem] font-semibold uppercase tracking-[0.15em] text-gold">
          {fromSource ? t(`whatsNew.source.${item.source_table}`) : t(`whatsNew.types.${item.type}`)}
        </span>
        {upcoming && (
          <span className="rounded-full border border-emerald-500/40 bg-emerald-950/30 px-2 py-0.5 text-[0.65rem] font-medium uppercase tracking-[0.12em] text-emerald-200">
            {t('whatsNew.upcoming')}
          </span>
        )}
        {dateLabel && (
          <span className="text-[0.7rem] text-ink-muted">{dateLabel}</span>
        )}
      </div>
      <h3 className="font-serif text-lg font-semibold text-cream">{item.title}</h3>
      {item.location && (
        <p className="text-sm text-ink-secondary">{item.location}</p>
      )}
      {item.description && (
        <p className="line-clamp-3 text-sm text-ink-secondary">{item.description}</p>
      )}
    </button>
  );
}
